import {get, post, del, patch} from "../api"
import * as url from "../url"
import { format } from 'react-string-format';

const apiGetGroupPermissionsList = data => {
  return get(format(url.API_GROUP_PERMISSIONS, data.groupId), data.history)
}

const apiPostGroupPermissionsNew = data => {
  return post(format(url.API_GROUP_PERMISSIONS, data.groupId), data.history, data.values)
}

const apiPatchGroupPermissionsEdit = data => {
  return patch(format(url.API_GROUP_PERMISSIONS_DETAIL, data.groupId, data.permissionId), data.history, data.values)
}

const apiDeleteGroupPermissionsDelete = data => {
  return del(format(url.API_GROUP_PERMISSIONS_DETAIL, data.groupId, data.permissionId), data.history)
}

const apiGetGroupPermissionsTypesList = data => {
  return get(format(url.API_GROUP_PERMISSIONS_TYPES, data.groupId), data.history)
}

const apiGetSectionsList = data => {
  return get(url.API_SECTIONS + "simple/", data.history)
}

const apiGetSegmentsList = data => {
  return get(url.API_SEGMENTS + "simple/", data.history)
}

export {
  apiGetGroupPermissionsList,
  apiPostGroupPermissionsNew,
  apiPatchGroupPermissionsEdit,
  apiDeleteGroupPermissionsDelete,
  apiGetGroupPermissionsTypesList,
  apiGetSectionsList,
  apiGetSegmentsList,
}
